import { render, staticRenderFns } from "./Rule_Panpae.vue?vue&type=template&id=4783267c&scoped=true&"
import script from "./Rule_Panpae.vue?vue&type=script&lang=js&"
export * from "./Rule_Panpae.vue?vue&type=script&lang=js&"
import style0 from "./Rule_Panpae.vue?vue&type=style&index=0&id=4783267c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4783267c",
  null
  
)

export default component.exports